import { render, staticRenderFns } from "./EventDayDashboard.vue?vue&type=template&id=56721243&scoped=true"
import script from "./EventDayDashboard.vue?vue&type=script&lang=js"
export * from "./EventDayDashboard.vue?vue&type=script&lang=js"
import style0 from "./EventDayDashboard.vue?vue&type=style&index=0&id=56721243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56721243",
  null
  
)

export default component.exports